module.exports = __webpack_public_path__ + "img/expert_bg.a6e8cc80.png";